"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeadSortableCell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const typings_1 = require("../typings");
const MosaicIcon_1 = require("../../../../Shared/Components/MosaicIcon");
const sortOrderType = {
    ascending: 'ascending',
    descending: 'descending',
    none: 'none',
};
class TableHeadSortableCell extends React.Component {
    constructor() {
        super(...arguments);
        this.handleKeyPress = (e) => {
            if (e.key === app_1.keyNameMapping.enter || e.key === app_1.keyNameMapping.space) {
                this.props.handleColumnHeaderClick(e);
            }
        };
        this.getSortType = () => {
            const { sortColumn, sortOrder, cellInfo: { name }, } = this.props;
            if (sortColumn !== name)
                return sortOrderType.none;
            return sortOrder === typings_1.OrderTypeEnum.Ascending
                ? sortOrderType.ascending
                : sortOrderType.descending;
        };
        this.getSortingPartOfLabel = (sortType) => {
            const { ascendingSortAriaLabel, descendingSortAriaLabel, notSortedAriaLabel } = this.props.sortingAriaLabels;
            if (sortType === sortOrderType.none) {
                return notSortedAriaLabel;
            }
            return sortType === sortOrderType.ascending ? ascendingSortAriaLabel : descendingSortAriaLabel;
        };
    }
    shouldComponentUpdate(nextProps) {
        const { sortOrder, sortColumn } = this.props;
        return sortOrder !== nextProps.sortOrder || sortColumn !== nextProps.sortColumn;
    }
    componentDidUpdate() {
        const { sortColumn, cellInfo: { name }, } = this.props;
        const isColumnWithChangedSorting = sortColumn === name;
        if (isColumnWithChangedSorting) {
            this.setLiveRegionMessage();
        }
    }
    render() {
        const { cellInfo, addHeaderCellRef, handleColumnHeaderClick, isNoData, className } = this.props;
        const cellName = cellInfo.name;
        const cellClassNames = `th-sortable px-md! subtitle-sm-strong ${isNoData ? 'no-data' : ''} ${className}`;
        const sortType = this.getSortType();
        const sortClassName = sortType !== sortOrderType.none ? sortType : '';
        return ((0, jsx_runtime_1.jsx)("th", { className: cellClassNames, ref: addHeaderCellRef, onClick: handleColumnHeaderClick, onKeyDown: this.handleKeyPress, "data-filter-group": cellName, scope: "col", "aria-sort": sortType, children: (0, jsx_runtime_1.jsx)("div", { className: "table--nested table w-full", role: "button", tabIndex: 0, children: (0, jsx_runtime_1.jsx)("div", { className: "table--nested-row table-row", children: (0, jsx_runtime_1.jsxs)("div", { className: "table--nested-cell table-cell align-middle text-left", children: [(0, jsx_runtime_1.jsx)("span", { className: "inline-block pr-1", children: cellInfo.label }), !isNoData && ((0, jsx_runtime_1.jsx)("span", { className: `table--sort-icons ${sortClassName} text-icon-accent-01-primary p-4xs hover:bg-fill-secondary-hovered active:bg-fill-secondary-pressed rounded-full`, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "unfold-more-outline", className: "icon-md" }) }))] }) }) }) }, cellName));
    }
    // Sets a message to notify screen reader user about sorting change.
    setLiveRegionMessage() {
        const { tableAriaLiveRef, cellInfo: { label }, } = this.props;
        const sortType = this.getSortType();
        const sortingChangeMessage = `${label} ${this.getSortingPartOfLabel(sortType)}`;
        const tableAriaLive = tableAriaLiveRef.current;
        if (!tableAriaLive)
            return;
        tableAriaLive.innerHTML = sortingChangeMessage;
    }
}
exports.TableHeadSortableCell = TableHeadSortableCell;
